var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7477 4.56316C30.7477 4.56316 30.454 2.49006 29.5496 1.57978C28.4044 0.381731 27.1242 0.375858 26.5369 0.305385C22.332 -1.68022e-07 16.0187 0 16.0187 0H16.007C16.007 0 9.69373 -1.68022e-07 5.48882 0.305385C4.90154 0.375858 3.62127 0.381731 2.47608 1.57978C1.57167 2.49006 1.2839 4.56316 1.2839 4.56316C1.2839 4.56316 0.978516 7.00036 0.978516 9.4317V11.7103C0.978516 14.1417 1.27803 16.5789 1.27803 16.5789C1.27803 16.5789 1.57167 18.652 2.4702 19.5623C3.6154 20.7603 5.11883 20.7192 5.78833 20.8484C8.19617 21.0774 16.0129 21.1479 16.0129 21.1479C16.0129 21.1479 22.332 21.1362 26.5369 20.8367C27.1242 20.7662 28.4044 20.7603 29.5496 19.5623C30.454 18.652 30.7477 16.5789 30.7477 16.5789C30.7477 16.5789 31.0472 14.1475 31.0472 11.7103V9.4317C31.0472 7.00036 30.7477 4.56316 30.7477 4.56316ZM12.9061 14.4764V6.02548L21.0282 10.2656L12.9061 14.4764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.497c7d49973f7bbbeed429bad2c9fa02.svg";
export { ForwardRef as ReactComponent };